export default __webpack_public_path__ + "static/media/hidraulic2.094c44ba.jpeg";